import { createFileRoute } from '@tanstack/react-router';

import SdkOnboarding from '~/app/onboarding/SdkOnboarding';

export const Route = createFileRoute('/_app/home/overview/onboarding/sdk')({
	beforeLoad: () => ({
		getTitle: 'Set up the SDK'
	}),
	component: function SdkSetupPage() {
		return <SdkOnboarding />;
	}
});
